import { render } from "./App.vue?vue&type=template&id=294961ee&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=294961ee&lang=css"
import "./App.vue?vue&type=style&index=1&id=294961ee&scoped=true&lang=scss"

import exportComponent from "F:\\fontre\\kia_project\\kia-k3-webgl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294961ee"]])

export default __exports__